export const getControlsWidth = ({ buttonsWidths, containerWidth, setAreButtonsVerticallyAlign, }) => {
    let buttonsWidth = 0;
    for (const width of buttonsWidths) {
        buttonsWidth += width;
    }
    if (buttonsWidth > containerWidth) {
        setAreButtonsVerticallyAlign(true);
    }
    else {
        setAreButtonsVerticallyAlign(false);
    }
};
//# sourceMappingURL=getControlsWidth.js.map